// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"2cf5aa37","230":"54f61849","243":"04728bbb","536":"9baabb82","632":"d6099c70","989":"37a12738"}[chunkId] + ".chunk.js";
};